<div class="header">
    <h3 class="title">
      {{ data.translations.title }}
    </h3>
</div>

<form class="form-content"
    [formGroup]="form"
    data-qa-label="AdvancedNoticePrepGroupDialogForm">

    <div class="item-add">
        <div class="group-content">
            <txp-item-list
                class="item-list"
                [disableSelectionReset]="false"
                [data]="productList"
                (emitSelection)="getSelectedItems($event)"
                [enableMultiSelect]="true"
                [enableSelection]="true"
                [filterText]="'menu.common.search' | translate"
                [header]="data.translations.listTitle"
                listKey="name">
            </txp-item-list>
        </div>

        <div class="actions">
            <i class="tce-icon-arrow-right arrow"></i>
            <txp-button
                (click)="onAdd()"
                data-qa-label="AddButton"
                [style]="buttonStyle.SECONDARY"
                [disabled]="false">
                {{ 'menu.createMenu.add' | translate }}
            </txp-button>
        </div>

        <div class="selected-content">
            <div *ngIf="!this.data.nameNotRequired">
                <mat-form-field>
                    <mat-label> {{ data.translations.group }} </mat-label>
                    <input matInput
                        data-qa-label="AdvancedNoticeGroupNameInput"
                        required
                        formControlName="name">
                    <mat-error>
                        {{ 'form.error.required' | translate }}
                    </mat-error>
                </mat-form-field>
            </div>

            <div class="title">{{ data.translations.listTitle }}</div>
            <div cdkDropList class="group-list" (cdkDropListDropped)="drop($event)">
                <div class="group-box" *ngFor="let item of addedItemsList" cdkDrag>
                    <span class="drag-icon">
                        <i class="tce-icon-grip"></i>
                    </span>
                    <span class="group-name"> {{ item.name }} </span>
                    <span class="remove-icon">
                        <i class="tce-icon-trash" (click)="onDelete(item)"></i>
                    </span>
                </div>
            </div>
            <div class="group-custom-placeholder" *cdkDragPlaceholder></div>
        </div>
    </div>
</form>

<div class="actions">
    <txp-button
        (click)="onCancel()"
        data-qa-label="CancelButton"
        [disabled]="isLoading"
        [style]="buttonStyle.SECONDARY">
        {{ 'form.button.cancel' | translate }}
    </txp-button>
    <txp-button
        data-qa-label="DoneButton"
        [disabled]="isDoneButtonDisabled()"
        [loading]="isLoading"
        [style]="buttonStyle.PRIMARY"
        (click)="onDone()">
        {{ 'menu.createMenu.done' | translate }}
    </txp-button>
</div>
